interface IContactInfo {
    email: string;
    phone: string;
}

export const contactInfo: IContactInfo = {
    email: 'dispatch@phoenixlosscontrol.com',
    phone: '888-749-5677',
}